import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductIndexLayoutEntityParams {
  layout: string;
}
export class ProductIndexLayoutEntity extends BaseEntityClass {
  layout: string;
  constructor(params: ProductIndexLayoutEntityParams) {
    super();
    this.type = "product_index_layout";
    this.entity_version = 2;
    this.layout = params.layout;
  }
}
